package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class CompetenceFamilyQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectAll(mapper: (
    id: String,
    name: String,
    description: String?,
    color: String,
    icon: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(1_561_725_822, arrayOf("competence_family"), driver,
      "CompetenceFamily.sq", "selectAll",
      "SELECT competence_family.id, competence_family.name, competence_family.description, competence_family.color, competence_family.icon, competence_family.order_index, competence_family.created_at, competence_family.updated_at, competence_family.is_deleted, competence_family.deleted_at, competence_family.synced_at FROM competence_family WHERE is_deleted = 0 ORDER BY order_index, name") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9),
      cursor.getLong(10)
    )
  }

  public fun selectAll(): Query<Competence_family> = selectAll { id, name, description, color, icon,
      order_index, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Competence_family(
      id,
      name,
      description,
      color,
      icon,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectById(id: String, mapper: (
    id: String,
    name: String,
    description: String?,
    color: String,
    icon: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9),
      cursor.getLong(10)
    )
  }

  public fun selectById(id: String): Query<Competence_family> = selectById(id) { id_, name,
      description, color, icon, order_index, created_at, updated_at, is_deleted, deleted_at,
      synced_at ->
    Competence_family(
      id_,
      name,
      description,
      color,
      icon,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectDirty(mapper: (
    id: String,
    name: String,
    description: String?,
    color: String,
    icon: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(1_877_619_311, arrayOf("competence_family"), driver,
      "CompetenceFamily.sq", "selectDirty",
      "SELECT competence_family.id, competence_family.name, competence_family.description, competence_family.color, competence_family.icon, competence_family.order_index, competence_family.created_at, competence_family.updated_at, competence_family.is_deleted, competence_family.deleted_at, competence_family.synced_at FROM competence_family WHERE synced_at IS NULL OR synced_at < updated_at") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9),
      cursor.getLong(10)
    )
  }

  public fun selectDirty(): Query<Competence_family> = selectDirty { id, name, description, color,
      icon, order_index, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Competence_family(
      id,
      name,
      description,
      color,
      icon,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByIdAnyState(id: String, mapper: (
    id: String,
    name: String,
    description: String?,
    color: String,
    icon: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdAnyStateQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9),
      cursor.getLong(10)
    )
  }

  public fun selectByIdAnyState(id: String): Query<Competence_family> = selectByIdAnyState(id) {
      id_, name, description, color, icon, order_index, created_at, updated_at, is_deleted,
      deleted_at, synced_at ->
    Competence_family(
      id_,
      name,
      description,
      color,
      icon,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun insert(
    id: String,
    name: String,
    description: String?,
    color: String,
    icon: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
  ) {
    driver.execute(-1_603_793_696, """
        |INSERT INTO competence_family(id, name, description, color, icon, order_index, created_at, updated_at)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 8) {
          bindString(0, id)
          bindString(1, name)
          bindString(2, description)
          bindString(3, color)
          bindString(4, icon)
          bindLong(5, order_index)
          bindLong(6, created_at)
          bindLong(7, updated_at)
        }
    notifyQueries(-1_603_793_696) { emit ->
      emit("competence_family")
    }
  }

  public fun update(
    name: String,
    description: String?,
    color: String,
    icon: String,
    order_index: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-1_258_847_504, """
        |UPDATE competence_family
        |SET name = ?, description = ?, color = ?, icon = ?, order_index = ?, updated_at = ?
        |WHERE id = ?
        """.trimMargin(), 7) {
          bindString(0, name)
          bindString(1, description)
          bindString(2, color)
          bindString(3, icon)
          bindLong(4, order_index)
          bindLong(5, updated_at)
          bindString(6, id)
        }
    notifyQueries(-1_258_847_504) { emit ->
      emit("competence_family")
    }
  }

  public fun reorder(
    order_index: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(958_618_548,
        """UPDATE competence_family SET order_index = ?, updated_at = ? WHERE id = ?""", 3) {
          bindLong(0, order_index)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(958_618_548) { emit ->
      emit("competence_family")
    }
  }

  public fun softDelete(
    deleted_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-2_065_171_172,
        """UPDATE competence_family SET is_deleted = 1, deleted_at = ?, updated_at = ? WHERE id = ?""",
        3) {
          bindLong(0, deleted_at)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(-2_065_171_172) { emit ->
      emit("competence_family")
    }
  }

  public fun restore(updated_at: Long, id: String) {
    driver.execute(962_383_175,
        """UPDATE competence_family SET is_deleted = 0, deleted_at = NULL, updated_at = ? WHERE id = ?""",
        2) {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(962_383_175) { emit ->
      emit("competence_family")
    }
  }

  public fun markSynced(
    synced_at: Long?,
    id: String,
    updated_at: Long,
  ) {
    driver.execute(-862_277_554,
        """UPDATE competence_family SET synced_at = ? WHERE id = ? AND updated_at <= ?""", 3) {
          bindLong(0, synced_at)
          bindString(1, id)
          bindLong(2, updated_at)
        }
    notifyQueries(-862_277_554) { emit ->
      emit("competence_family")
    }
  }

  private inner class SelectByIdQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("competence_family", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("competence_family", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(1_168_901_525,
        """SELECT competence_family.id, competence_family.name, competence_family.description, competence_family.color, competence_family.icon, competence_family.order_index, competence_family.created_at, competence_family.updated_at, competence_family.is_deleted, competence_family.deleted_at, competence_family.synced_at FROM competence_family WHERE id = ? AND is_deleted = 0""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "CompetenceFamily.sq:selectById"
  }

  private inner class SelectByIdAnyStateQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("competence_family", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("competence_family", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(1_778_889_402,
        """SELECT competence_family.id, competence_family.name, competence_family.description, competence_family.color, competence_family.icon, competence_family.order_index, competence_family.created_at, competence_family.updated_at, competence_family.is_deleted, competence_family.deleted_at, competence_family.synced_at FROM competence_family WHERE id = ?""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "CompetenceFamily.sq:selectByIdAnyState"
  }
}
